import ReportTable from '@components/ReportTable/ReportTable';
import { WallImageSet } from '../WallReportModal/WallModalModalContent'
import styles from './MyoReportModalContext.module.scss'
import { REPORT_MODAL_NAMES } from 'config/labels';

export interface CoronaryAnalysis {
  totalAnalysis: {
    coronaryArteryTotalVolume: number;
    lvMuscleMass: number;
    vmRatio: number;
  };
  lvMassDistribution: {
    rca: { mass: number; percentage: number };
    lad: { mass: number; percentage: number };
    lcx: { mass: number; percentage: number };
  };
  myocardialMassAtRisk: {
    coronaryVolume: number;
    lvMuscleMass: { mass: number; percentage: number };
    vmRatio: number;
  };
}

interface Props {
  imageSrc? : {
    images? : WallImageSet;
  };
  value? : CoronaryAnalysis;
}

const wallKeyMapping = {
  'Anterior': 'one',
  'Posterior': 'six',
  'Left ': 'two',
  'Right': 'three',
  'Head': 'five',
  'Feet': 'four'
}
export default function MyoReportModalContent({
  imageSrc,
  value,
}: Props){
  const Images = imageSrc?.images || {};
  const names = REPORT_MODAL_NAMES.myocardial;
  return (
    <div className={styles['main-container']}>
      <div className={styles['content-container']}>
        <div className={styles['image-container']}>
          <img src={imageSrc?.images?.one} />
        </div>
        <div className={styles['table-container']}>
          <ReportTable
            className={'myocardial-report'}
            title={names.sections.totalAnalysis.title}
            columns={names.sections.totalAnalysis.columns}
            rows={[
              { label: names.sections.totalAnalysis.labels.coronaryArteryTotalVolume, values: [`${value?.totalAnalysis.coronaryArteryTotalVolume} mm³`] },
              { label: names.sections.totalAnalysis.labels.lvMuscleMass, values: [`${value?.totalAnalysis.lvMuscleMass} g`] },
              { label: names.sections.totalAnalysis.labels.vmRatio, values: [`${value?.totalAnalysis.vmRatio} mm³/g`] },
            ]}
          />
          <ReportTable
            className={'myocardial-report'}
            title={names.sections.lvMassDistribution.title}
            columns={names.sections.lvMassDistribution.columns}
            rows={[
              { label: names.sections.lvMassDistribution.labels.rca, values: [`${value?.lvMassDistribution.rca.mass} g`, `${value?.lvMassDistribution.rca.percentage}%`] },
              { label: names.sections.lvMassDistribution.labels.lad, values: [`${value?.lvMassDistribution.lad.mass} g`, `${value?.lvMassDistribution.lad.percentage}%`] },
              { label: names.sections.lvMassDistribution.labels.lcx, values: [`${value?.lvMassDistribution.lcx.mass} g`, `${value?.lvMassDistribution.lcx.percentage}%`] },
            ]}
          />
          <ReportTable
            className={'myocardial-report'}
            title={names.sections.myocardialMassAtRisk.title}
            columns={names.sections.myocardialMassAtRisk.columns}
            rows={[
              { label: names.sections.myocardialMassAtRisk.labels.coronaryVolume, values: [`${value?.myocardialMassAtRisk.coronaryVolume} mm³`] },
              { label: names.sections.myocardialMassAtRisk.labels.lvMuscleMass, values: [`${value?.myocardialMassAtRisk.lvMuscleMass.mass} g (${value?.myocardialMassAtRisk.lvMuscleMass.percentage}%)`] },
              { label: names.sections.myocardialMassAtRisk.labels.vmRatio, values: [`${value?.myocardialMassAtRisk.vmRatio} mm³/g`] },
            ]}
          />
        </div>
      </div>
    </div>
  )
}
